module.exports = __webpack_public_path__ + "static/img/bmw-cic-lrp.3c03370.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/bmw-cic-lrp.jpg
// module id = dzoQ
// module chunks = 0